import DynamicForm from "../../../../components/FormElements/DynamicForm";
import { FaEnvelope, FaMinusSquare } from "react-icons/fa";
import { FaEye } from "react-icons/fa";
import { Checkbox, Col, Radio, Row } from "antd";
import logo from '../../../../assets/images/logo.png'
import AuthLayout from "../../../../components/Layout/AuthLayout";
import './style.css'
import Button from "../../../../components/FormElements/Button";
import { FaUserTie } from "react-icons/fa";
import { MdOutlineContactPhone } from "react-icons/md";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { CiCircleCheck } from "react-icons/ci";
import { FaRegCircle } from "react-icons/fa";
import LocationPicker from "../../../../components/LocationPicker";
import { authTypes, socialLogin } from "../../../../config/utils/constants";
import { FacebookAuthProvider, GoogleAuthProvider, OAuthProvider, signInWithPopup } from 'firebase/auth'
import { auth, generateFCMToken } from "../../../../config/firebase/firebase";
import useAuthApi from "../../../../config/hooks/api/auth/useAuthApi";
import { useDispatch, useSelector } from "react-redux";
import { setAppLoading, setError, setMessage } from "../../../../store/common/generalSlice";
import { FaPlusSquare } from "react-icons/fa";
import { autoGetLocationFormSchema, manualGetLocationFormSchema } from "./schema";
import userLocationRetrieve from "../../../../config/utils/UserLocationRetrieve";
import ReverseGeocoding from "../../../../config/utils/ReverseGeoCoding";
import { generateFallbackDeviceToken, getFcmToken } from "../../../../config/utils";

const signupTypes = [
  { name: 'Service User', value: 'user' },
  { name: 'Service Provider', value: 'sp' }
];

const SignUp = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams();
  const role = searchParams.get('role');

  const { signUp, socialSignUp, switchAccountSignup } = useAuthApi()

  const { logoutByExpertAction } = useSelector(state => state?.auth);
  const { profileData } = useSelector(state => state?.setting);

  const [selectedForm, setSelectedForm] = useState(logoutByExpertAction ? signupTypes[1] : signupTypes[0])
  const [resetFormData, setResetFormData] = useState(false)
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [currentLocation, setCurrentLocation] = useState(null)
  const [manualAddress, setManualAddress] = useState(false)
  const [manualAddressForm, setManualAddressForm] = useState([
    {
      name: 'address1',
      type: 'text',
      label: { value: 'Address Line 1', style: '', classes: '' },
      placeholder: '4058 Little York Rd.',
      width: { md: 12, sm: 12, xs: 24 },
      component: null,
      classes: 'icon-primary',
      icon: null
    },
    {
      name: 'address2',
      type: 'text',
      label: { value: 'Address Line 2(Optional)', style: '', classes: '' },
      placeholder: '4058 Little',
      width: { md: 12, sm: 12, xs: 24 },
      component: null,
      classes: 'icon-primary',
      icon: null
    },
    {
      name: 'town',
      type: 'text',
      label: { value: 'Town', style: '', classes: '' },
      placeholder: 'York Rd.',
      width: { md: 12, sm: 12, xs: 24 },
      component: null,
      classes: 'icon-primary',
      icon: null
    },
    {
      name: 'postalCode',
      type: 'text',
      label: { value: 'Postal Code', style: '', classes: '' },
      placeholder: 'YAK-9876',
      width: { md: 12, sm: 12, xs: 24 },
      component: null,
      classes: 'icon-primary',
      icon: null
    },
  ])
  const [form, setForm] = useState({
    name: 'spSignupForm',
    formFields: [
      {
        name: 'fullName',
        type: 'text',
        label: { value: 'Full Name', style: '', classes: '' },
        placeholder: 'Mark Smith',
        width: { md: 12, sm: 12, xs: 24 },
        component: null,
        classes: 'icon-primary',
        icon: <FaUserTie />,
        // readOnly: logoutByExpertAction ? true : false
      },
      {
        name: 'email',
        type: 'email',
        label: { value: 'Email Address', style: '', classes: '' },
        placeholder: 'marksmith@gmail.com',
        width: { md: 12, sm: 12, xs: 24 },
        component: null,
        classes: 'icon-primary',
        icon: <FaEnvelope />,
        readOnly: logoutByExpertAction ? true : false
      },
      {
        name: 'phoneNo',
        type: 'text',
        label: { value: 'Phone Number', style: '', classes: '' },
        placeholder: 'Enter Phone Number',
        width: { md: 12, sm: 12, xs: 24 },
        component: null,
        classes: 'icon-primary',
        icon: <MdOutlineContactPhone />,
        readOnly: logoutByExpertAction ? true : false
      },
      {
        name: 'location',
        type: 'custom',
        label: { value: 'Location', style: '', classes: '' },
        placeholder: '4058 Little York Rd, Houston',
        width: { md: 12, sm: 12, xs: 24 },
        component: <LocationPicker />,
        classes: 'icon-primary mb-0',
        icon: <MdOutlineContactPhone />
      },
      {
        name: 'manualLocation',
        type: 'custom',
        label: { value: '', style: '', classes: 'checkbox-label' },
        placeholder: '',
        width: { md: 24, sm: 24, xs: 24 },
        component: <ManualAddressForm onCheckChange={handleChange} />,
        classes: 'icon-primary',
        icon: null
      },
      {
        name: 'password',
        type: 'password',
        label: { value: 'Password', style: '', classes: `${logoutByExpertAction ? 'hidden' : ''}` },
        placeholder: 'Password',
        width: { md: 12, sm: 12, xs: 24 },
        component: null,
        classes: `icon-primary ${logoutByExpertAction ? 'hidden' : ''}`,
        icon: <FaEye />
      },
      {
        name: 'confirmPassword',
        type: 'password',
        label: { value: 'Re-enter Password', style: '', classes: `${logoutByExpertAction ? 'hidden' : ''}` },
        placeholder: 'Password',
        width: { md: 12, sm: 12, xs: 24 },
        component: null,
        classes: `icon-primary ${logoutByExpertAction ? 'hidden' : ''}`,
        icon: <FaEye />
      },
      {
        name: 'dataVerificationAgreement',
        type: 'custom',
        label: { value: '', style: '', classes: 'checkbox-label' },
        placeholder: '',
        width: { md: 24, sm: 24, xs: 24 },
        component: <DataVerificationAgreement onCheckChange={handleChange} />,
        classes: 'icon-primary',
        icon: null
      },
    ],
  })
  const [hasUserAgreed, setHasUserAgreed] = useState(false)
  const [prefilledData, setPrefilledData] = useState(null);

  useEffect(() => {
    if (logoutByExpertAction && profileData) {
      setPrefilledData(
        {
          fullName: profileData?.fullName,
          email: profileData?.email,
          phoneNo: profileData?.phoneNo
        }
      )
    }
  }, [profileData])


  const handleSubmit = async (values) => {
    try {
      if (!values || !Object.keys(values).length) {
        dispatch(setError("Fields should not be empty"))
        return
      }
      for (let key in values) {
        if (!values[key]) delete values[key]
      }

      const location = structuredClone(values?.location)
      let { lat, lng, city, country, address, postalCode, town } = location
      const { fullName, email, phoneNo, password } = values

      country = !country && values?.country ? values?.country : 'Not available'
      city = !city && values?.city ? values?.city : 'Not available'
      postalCode = !postalCode && values?.postalCode ? values?.postalCode : '00000'
      town = !town && values?.town ? values?.town : 'Not available'
      const rem = { fullName, email, phoneNo, password, city, country, address, postalCode, town }

      const findElementsByChar = (values, char) => {
        if (!values || !values.length || !char) return false

        const idxs = []
        for (let i = 0; i < values.length; i++) {
          if (values[i] == char) idxs.push(i)
        }
        return idxs
      }

      let payload;
      if (logoutByExpertAction) {
        payload = {
          longitude: lng,
          latitude: lat,
          password,
          city,
          country,
          address
        }
      }
      else {
        payload = {
          longitude: lng,
          latitude: lat,
          platform: 'web',
          addressLine1: (address && address.length) ?
            address.slice(0, findElementsByChar(address, ',')[2]) :
            !address && values?.address ? values?.address : 'Not available',
          addressLine2: (address && address.length) ?
            address.slice(findElementsByChar(address, ',')[2]) :
            !address && values?.address ? values?.address : 'Not available',
          type: selectedForm.value == 'user' ? "Service User" : "Service Provider",
          ...rem
        }
      }

      dispatch(setAppLoading(true))

      let response;
      if (logoutByExpertAction) {
        response = await switchAccountSignup(payload)
      }
      else {
        response = await signUp(payload)
      }
      if (response) {
        if (!logoutByExpertAction) {
          if (!response?.data?.user || !Object.keys(response?.data?.user).length) {
            dispatch(setError("Required user data"))
            dispatch(setAppLoading(false))
            return
          }
          const tempData = response?.data?.user
          tempData.type = authTypes.indexOf('signUp')
          localStorage.setItem('tempUser', JSON.stringify(tempData))
        }
        dispatch(setMessage(response?.data?.message))
        dispatch(setAppLoading(false))
        navigate(logoutByExpertAction ? '/login' : '/verify-otp')
      }
    } catch (error) {
      console.log(error)
      dispatch(setAppLoading(false))
    }

  }

  const submitForm = () => {
    document.querySelector('form')?.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }))
  }

  const handleModeChange = (e) => {
    setSelectedForm(signupTypes.filter(v => v.value === e.target.value)[0])
    setResetFormData(true)
  };

  const getLocationForManualSignup = (data) => {
    if (data) {
      if (data?.location) {
        setCurrentLocation(data.location)
      }
    }
  }


  const getCurrentLocation = async () => {
    const coords = await userLocationRetrieve()
    if (coords?.latitude) {
      const location = await ReverseGeocoding({ lat: coords?.latitude, lng: coords?.longitude })
      return {
        lat: coords?.latitude,
        lng: coords?.longitude,
        address: location?.formatted_address,
        postalCode: location?.postalCode,
        town: location?.town,
        city: location?.city,
        country: location?.country
      }
    }
  }

  const handleSocialLogin = async (loginType, manualResponse = null) => {
    try {
      if (loginType) {
        dispatch(setAppLoading(true))

        let provider, result;
        if (loginType === 'facebook') {
          provider = new FacebookAuthProvider()

          result = await signInWithPopup(auth, provider)
        }
        else if (loginType === 'apple') {
          // if(manualResponse){
          //   result = manualAddress
          // }
          provider = new OAuthProvider('apple.com');

          result = await signInWithPopup(auth, provider)
        }
        else if (loginType === 'google') {
          provider = new GoogleAuthProvider()

          provider.setCustomParameters({
            prompt: 'select_account', // Forces the account selection screen
          });

          result = await signInWithPopup(auth, provider)
        }

        if (result) {
          const { user } = result
          const { displayName: fullName, email, providerData, accessToken: socialToken } = user
          const { lat, lng } = await getCurrentLocation()
          const fcmToken = await getFcmToken()

          // a case if device token is null means the device is not supported then a temp device token
          // generated to let the user login at least.
          if (fcmToken === null) {
            const fallbackToken = generateFallbackDeviceToken();
            if (fallbackToken) {
              localStorage.setItem('fcmToken', fallbackToken);
              // dispatch(setMessage("Alternative notification system activated."));
              fcmToken = fallbackToken
            }
          }

          // supported device but notifications are disable. 
          else if (!fcmToken) {
            dispatch(setError('Required fcm token'))
            dispatch(setAppLoading(false))
            return
          }

          const payload = {
            fullName,
            email,
            lat,
            lng,
            socialId: providerData.length && providerData[0].uid,
            socialPlatform: loginType,
            city: currentLocation?.city ? currentLocation?.city : 'Not available',
            country: currentLocation?.country ? currentLocation?.country : 'Not availale',
            platform: 'web',
            fcmToken: fcmToken,
            socialToken,
            type: selectedForm.name
          }

          const response = await socialSignUp(payload)
          if (response) {
            dispatch(setMessage(response?.data?.message))
            dispatch(setAppLoading(false))
            localStorage.setItem('tempUser', JSON.stringify(response?.data?.data))
            navigate('/login')
          }
        }
      }
    } catch (error) {
      console.log(error)
      dispatch(setAppLoading(false))
    }
  }

  function handleChange(data) {
    if (!data) return

    if (data?.name == 'manualLocation') {
      setManualAddress(data?.value)
    }
    else setHasUserAgreed(data?.value)
  }

  const handleFormResponse = (data) => {
    if (!data) return

    getLocationForManualSignup(data)
  }


  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };

  }, []);

  useEffect(() => {
    if (manualAddress === true) {
      // Index to insert new objects
      const index = 5; //insert before password field

      // Insert new objects
      const result = [
        ...form.formFields.slice(0, index),
        ...manualAddressForm,
        ...form.formFields.slice(index)
      ];

      // in case of switching a profile neglecting password, confirm password validations check
      // as in this case these two fields are hidden.
      if (logoutByExpertAction) {
        const { password, confirmPassword, ...restOfTheValidations } = manualGetLocationFormSchema;
        setForm({ ...form, formFields: result, formValidation: restOfTheValidations })
      }
      else {
        setForm({ ...form, formFields: result, formValidation: manualGetLocationFormSchema })
      }

    }
    else {
      const filtered = form.formFields.filter(e => !manualAddressForm.map(item => item.name).includes(e.name))
      // setForm({ ...form, formFields: filtered })

      // in case of switching a profile neglecting password, confirm password validations check
      // as in this case these two fields are hidden.
      if (logoutByExpertAction) {
        const { password, confirmPassword, ...restOfTheValidations } = autoGetLocationFormSchema;
        setForm({
          ...form,
          formFields: filtered,
          formValidation: restOfTheValidations
        })
      }
      else {
        setForm({
          ...form,
          formFields: filtered,
          formValidation: autoGetLocationFormSchema
        })
      }
    }
  }, [manualAddress])

  useEffect(() => {
    setResetFormData({
      location: null
    })
  }, [selectedForm])

  useEffect(() => {
    if (role) {
      const selectedrole = role.toLowerCase().includes('provider') ? signupTypes[1] : signupTypes[0]
      setSelectedForm(selectedrole)
    }
  }, [role])


  return (
    <AuthLayout>
      <Row className="flex justify-center signup-screens">
        <Col xs={24} sm={18} md={18} className="form-section custom-card-boxshadow px-4 py-5 rounded-md">
          <img src={logo} alt='logo' className="img-fluid logo mb-8" />
          <h4 className="heading-4 font-bold mb-4">Register Now</h4>
          <p className="text-slate-500 mb-4">Vehicle Experts - Maximize sales</p>
          {
            !logoutByExpertAction &&
            <div className="mb-4 flex-nowrap">
              <Radio.Group
                onChange={handleModeChange}
                value={selectedForm.value}
                className="mb-8 flex flex-nowrap items-center"
              >
                {signupTypes.map(item => (
                  <Radio.Button
                    key={item.value}
                    value={item.value}
                    className={item.value == selectedForm.value && "selected-tab"}
                  >
                    <div className="flex justify-between items-center">
                      {item.value == selectedForm.value ? (
                        <CiCircleCheck className="text-black bg-primary rounded-full" />
                      ) :
                        <FaRegCircle />
                      }
                      <span className="ml-2 p-2 lg:text-md md:text-md sm:text-md text-xs text-nowrap">
                        {item.name}
                      </span>
                    </div>
                  </Radio.Button>
                ))}
              </Radio.Group>
            </div>
          }

          <DynamicForm
            onSubmit={handleSubmit}
            form={form}
            reset={resetFormData}
            onChange={handleFormResponse}
            editData={logoutByExpertAction ? prefilledData : resetFormData}
          />

          <div className="text-slate-300 dashed-line w-full mb-3"></div>
          <Row className="w-full mb-3">
            <Col md={16} sm={16} xs={24} className="md:mb-0 sm:mb-0 mb-2 md:text-left sm:text-left text-center">
              <small className="text-slate-500 block">By creating an account you agree to our</small>
              <div className="flex flex-col sm:flex-row gap-1 sm:gap-4 mt-2">
                <a className='text-primary text-xs font-semibold' href='https://mobrage.com/terms-and-conditions/' target="_blank">
                  Terms & conditions
                </a>
                {/* <small className="ml-1 text-xs text-primary font-semibold">and </small> */}
                <a className='text-primary text-xs font-semibold' href='https://mobrage.com/privacy-policy/' target="_blank">
                  Privacy Policy
                </a>
              </div>
            </Col>
            <Col md={8} sm={8} xs={24} className="md:text-right sm:text-right text-center">
              <Button.Basic
                onClick={submitForm}
                disabled={!hasUserAgreed}
                icon={null}
                loading={false}
                type="primary"
                size='medium'
                text='Sign Up'
                className='btn-primary md:w-fit sm:w-fit w-full'
              />
            </Col>
          </Row>
          <div className="text-slate-300 dashed-line w-full mb-3"></div>
          <div className="flex w-full justify-between mb-3 items-center">
            <div>
              <small className="text-slate-400">Already have an account?</small>
              <Link to='/login' className="ml-1 font-bold">Login</Link>
            </div>
            <div className="flex pt-1">
              <p className="text-xs text-slate-400">Or Continue With:</p>
              <div className="flex justify-center">
                {socialLogin.map(item => (
                  <span onClick={() => handleSocialLogin(item?.name, null)} key={item?.name} className="ml-2">
                    {item?.icon}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </AuthLayout>
  );
};


export default SignUp;




const ManualAddressForm = ({ onCheckChange }) => {
  const [manualAddress, setManualAddress] = useState(false)

  const handleChange = () => {
    setManualAddress(prev => !prev)
  };

  useEffect(() => {
    onCheckChange({
      name: 'manualLocation',
      value: manualAddress
    })
  }, [manualAddress])


  return (
    <div className="mb-3 cursor-pointer">
      {/* <Checkbox className="checkbox-primary" onChange={handleChange}>I agree that this information is true</Checkbox> */}
      <div className="flex justify-end items-center" onClick={handleChange} >
        {manualAddress ? (
          <FaMinusSquare className="text-primary" />
        ) : (
          <FaPlusSquare className="text-primary" />
        )}
        <small className="ml-2">Add Manually</small>
      </div>
    </div>
  );
}


const DataVerificationAgreement = ({ onCheckChange }) => {
  const handleChange = (e) => {
    onCheckChange({
      name: 'dataVerificationAgreement',
      value: e.target.checked
    })
  };

  return (
    <div className="flex justify-start items-center mt-6 mb-2">
      <Checkbox className="checkbox-primary flex items-center" onChange={handleChange}>
        <small className="text-xs font-semibold mb-0">I agree that this information is true</small>
      </Checkbox>
    </div>
  )
};
